export default "__VITE_ASSET__0ab4_SF2cYHJR5T4FIuGpw__";